<template>
  <div class="criteria-list">
    <div class="row">
      <div class="col-12">
        <label class="font-weight-bold my-3 largeSectionTitle"> Liste </label>
      </div>
      <div
        v-for="(listItem, listItemIndex) in criteriaListEntries"
        :key="listItemIndex"
        class="col-12 d-flex"
      >
        <br>
        <v-text-field
          v-model="listItem.order"
          :disabled="!canUserEdit"
          class="col-1"
          label="Sortierung"
          type="number"
          @input="emitUpdate"
        >
          <template
            v-if="
              criteriaListEntries.filter((item) => {
                return item.order == listItem.order;
              }).length > 1
            "
            slot="append"
          >
            <i
              class="small"
              style="color: red"
            >Doppelte Sortierung</i>
          </template>
        </v-text-field>
        <u-multiline-multilanguage-text-input
          :id="'listItemValueInput' + listItemIndex"
          v-model="listItem.contents"
          :hide-languages="true"
          :is-multiline="true"
          :languages="
            $store.state.mindestLohnKonfiguration.BasicContractInformation
              .translatedLanguages
          "
          :readonly="!canUserEdit"
          content-property-name="text"
          @input="emitUpdate"
        />
        <v-select
          v-if="
            $store.state.mindestLohnKonfiguration.Configuration
              .qualificationLevelEnabled
          "
          v-model="listItem.qualificationLevel"
          :disabled="!canUserEdit"
          :items="qualificationLevels"
          class="ml-2"
          placeholder="Qualifikationsstufe"
          style="min-width: 316px"
          text="text"
          value="value"
          @input="emitUpdate"
        />
        <button
          v-if="canUserEdit"
          v-b-tooltip.hover
          class="btn btn-danger float-right actionButton"
          placement="bottom"
          title="Diesen Listeneintrag löschen"
          type="button"
          @click="removeListItem(criteriaListEntries, listItemIndex)"
        >
          <i class="fas fa-trash-alt" />
        </button>
      </div>
    </div>
    <div class="row justify-content-end">
      <div class="col-3">
        <v-select
          v-model="criteriaToImportId"
          :items="criterias"
          item-text="title"
          item-value="id"
          label="Listeneintrag"
        />
      </div>

      <div>
        <b-button
          v-if="canUserEdit"
          v-b-tooltip.hover
          class="mt-2"
          title="Listeneintrag importieren"
          variant="success"
          @click="emitImport(criteriaToImportId)"
        >
          <i class="fas fa-solid fa-file-import" />
        </b-button>
      </div>

      <div class="col-auto">
        <button
          v-if="canUserEdit"
          v-b-tooltip.hover
          class="btn btn-success actionButton mt-2"
          title="Neuen Listeneintrag erfassen"
          type="button"
          @click="addNewListItem(criteriaListEntries)"
        >
          <i class="fas fa-plus" />
        </button>
      </div>
    </div>
    <div class="row">
      <b-button
        v-if="canUserEdit"
        :disabled="
          new Set(criteriaListEntries.map((a) => a.order.toString())).size <
            criteriaListEntries.length
        "
        class="mt-2"
        name="saveStrucuture"
        variant="success"
        @click="emitSave()"
      >
        Speichern
      </b-button>
      <b-button
        v-if="canUserEdit"
        class="mt-2 ml-2"
        name="loadStructure"
        variant="danger"
        @click="emitCancel()"
      >
        Abbrechen
      </b-button>
    </div>
  </div>
</template>

<script>
import { MinimumWageMixin } from "@/components/minimum.wage/mixins/MinimumWageMixin";

export default {
  name: "CriteriaList",
  mixins: [MinimumWageMixin],
  props: {
    value: {
      type: Array,
      required: true,
    },
    criterias: {
      type: Array,
      default: () => [],
    },
    qualificationLevels: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      criteriaListEntries: {},
      criteriaToImportId: 0,
    };
  },
  created() {
    this.criteriaListEntries = JSON.parse(JSON.stringify(this.value));
  },
  methods: {
    addNewListItem(list) {
      var order = 10;
      var lastEntry = list.slice(-1).pop();
      if (lastEntry != undefined) {
        order = lastEntry.order + 10;
      }

      list.push({
        id: 0,
        criteriaId: 0,
        code: "newListEntry",
        contents: this.getCurrentLanguagesContents(),
        order: order,
      });
      this.emitUpdate();
    },
    removeListItem(collection, index) {
      collection.splice(index, 1);
      this.emitUpdate();
    },
    getCurrentLanguagesContents() {
      let counter = 0;
      const contents = [];
      this.$store.state.mindestLohnKonfiguration.BasicContractInformation.translatedLanguages.forEach(
        (translatedLanguage) => {
          contents.push({
            id: 0,
            criteriaStructureId: 0,
            value: "",
            language: translatedLanguage.language,
          });
          counter++;
        },
      );

      if (
        this.$store.state.mindestLohnKonfiguration.BasicContractInformation
          .translatedLanguages.length == counter
      ) {
        return contents;
      }
    },
    emitUpdate() {
      this.$emit("input", this.criteriaListEntries);
    },
    emitSave() {
      this.$emit("save", this.criteriaListEntries);
    },
    emitImport(criteriaToImportId) {
      this.$emit("import", criteriaToImportId);
    },
    emitCancel() {
      this.$emit("cancel");
    },
  },
};
</script>

<style scoped>
.actionButton {
  height: 34px;
  margin-top: 15px;
  margin-left: 10px;
}

.smallActionButton {
  width: 25px;
  height: 25px;
  font-size: 17px;
  padding: 0px;
}
</style>
